// lib/supabase/client.ts
import { createBrowserClient as createSSRBrowserClient } from '@supabase/ssr';
import { SupabaseClient } from '@supabase/supabase-js';

// Define a type alias for the specific Supabase client type your application uses.
type Database = Record<string, never>; // placeholder until you have real types
export type AppSupabaseClient = SupabaseClient<Database, 'public'>;

// This variable will hold the single client instance.
let client: AppSupabaseClient | undefined;

function getSupabaseClient(): AppSupabaseClient {
  // If the client doesn't exist yet, create it.
  if (!client) {
    const genericClient = createSSRBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
    );
    // Cast the generic client to the specific type your application needs.
    client = genericClient as unknown as AppSupabaseClient;
  }
  
  // Return the existing, correctly typed client.
  return client;
}

// Export the single, initialized instance for the entire app to use.
export const supabaseClient = getSupabaseClient();